// Simple MQL4 syntax highlighter — returns array of {type, text} tokens per line
const KEYWORDS = new Set([
  "if","else","for","while","do","switch","case","break","continue","return",
  "true","false","void","input","extern","static","const","new","delete","this",
  "public","private","protected","virtual","class","struct","enum","typedef",
]);
const TYPES = new Set([
  "int","double","string","bool","char","long","short","uchar","uint","ulong","ushort",
  "datetime","color","MqlRates","MqlTick","ENUM_TIMEFRAMES","ENUM_APPLIED_PRICE",
]);
const MQL_FUNCS = new Set([
  "OnInit","OnDeinit","OnTick","OnStart","OrderSend","OrderClose","OrderModify",
  "OrderSelect","OrderTicket","OrderType","OrderSymbol","OrderMagicNumber","OrderLots",
  "OrderOpenPrice","OrderStopLoss","OrderTakeProfit","OrdersTotal",
  "iRSI","iMA","iMACD","iBands","iStochastic","iIchimoku","iATR","iADX","iCCI",
  "iClose","iOpen","iHigh","iLow","iVolume","iTime","iBarShift",
  "NormalizeDouble","MarketInfo","Print","Comment","Alert","Symbol","Point","Digits",
  "SymbolInfoDouble","SymbolInfoInteger","TimeCurrent","StringFormat",
  "Bid","Ask",
]);

function tokenizeLine(line) {
  const tokens = [];
  let i = 0;
  while (i < line.length) {
    // Comments
    if (line[i] === "/" && line[i + 1] === "/") {
      tokens.push({ type: "comment", text: line.slice(i) });
      break;
    }
    // Preprocessor
    if (line[i] === "#") {
      const rest = line.slice(i);
      tokens.push({ type: "macro", text: rest });
      break;
    }
    // Strings
    if (line[i] === '"') {
      let j = i + 1;
      while (j < line.length && line[j] !== '"') { if (line[j] === "\\") j++; j++; }
      tokens.push({ type: "string", text: line.slice(i, j + 1) });
      i = j + 1;
      continue;
    }
    // Numbers
    if (/\d/.test(line[i])) {
      let j = i;
      while (j < line.length && /[\d.]/.test(line[j])) j++;
      tokens.push({ type: "number", text: line.slice(i, j) });
      i = j;
      continue;
    }
    // Identifiers
    if (/[A-Za-z_]/.test(line[i])) {
      let j = i;
      while (j < line.length && /[A-Za-z0-9_]/.test(line[j])) j++;
      const w = line.slice(i, j);
      let type = "plain";
      if (KEYWORDS.has(w)) type = "keyword";
      else if (TYPES.has(w) || w.startsWith("ENUM_") || w.startsWith("MODE_") || w.startsWith("PERIOD_") || w.startsWith("PRICE_") || w.startsWith("OP_") || w.startsWith("SELECT_") || w.startsWith("clr")) type = "type";
      else if (MQL_FUNCS.has(w)) type = "function";
      tokens.push({ type, text: w });
      i = j;
      continue;
    }
    tokens.push({ type: "plain", text: line[i] });
    i++;
  }
  return tokens;
}

export function highlightMql4(code) {
  const lines = (code || "").split("\n");
  return lines.map(tokenizeLine);
}
